import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import './animations.css';
import App from './App';
import Success from './Success';
import Cancel from './Cancel';
import LegalPage from './components/LegalPage';
import NotFoundPage from './components/NotFoundPage';
import ContactPage from './components/ContactPage';
import { AuthProvider } from './AuthContext';
import { AuthModalProvider } from './AuthModalContext';
import { CartProvider } from './CartContext';
import CartDrawer from './components/CartDrawer';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[OVR ErrorBoundary]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#080808', color: '#fff', fontFamily: 'Inter, sans-serif', padding: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠</div>
          <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 36, letterSpacing: '0.08em', marginBottom: 8 }}>SOMETHING WENT WRONG</h1>
          <p style={{ color: '#666', fontSize: 14, marginBottom: 24 }}>An unexpected error occurred. Please refresh the page to try again.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: 'transparent', border: '1px solid rgba(157,21,21,0.6)', color: '#9D1515', fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, letterSpacing: '0.1em', padding: '10px 24px', cursor: 'pointer' }}
          >
            REFRESH PAGE
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <AuthModalProvider>
          <CartProvider>
            <Router>
              <Routes>
                <Route path="/privacy" element={<LegalPage kind="privacy" />} />
                <Route path="/terms" element={<LegalPage kind="terms" />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/404" element={<NotFoundPage />} />
                <Route path="/success" element={<Success />} />
                <Route path="/cancel" element={<Cancel />} />
                <Route path="/*" element={<App />} />
              </Routes>
            </Router>
            <CartDrawer />
          </CartProvider>
        </AuthModalProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
